import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import API from "../api.js";

const Test = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQ, setCurrentQ] = useState(0);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [finished, setFinished] = useState(false);
  const [redirectToLogin, setRedirectToLogin] = useState(false);

  const token = localStorage.getItem("token");

  // 🔹 FETCH QUESTIONS (FIXED)
  useEffect(() => {
    if (!token) {
      setRedirectToLogin(true);
      return;
    }

    API.get("/questions")
      .then((res) => {
        if (Array.isArray(res.data)) {
          setQuestions(res.data);
        } else if (Array.isArray(res.data.questions)) {
          setQuestions(res.data.questions);
        } else {
          console.warn("Invalid question format:", res.data);
          setQuestions([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching questions:", err);
        setRedirectToLogin(true);
      });
  }, [token]);

  // 🔹 TIMER LOGIC
  useEffect(() => {
    if (!questions.length || finished) return;

    if (timeLeft <= 0) {
      handleNext();
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, finished, questions]);

  const handleAnswer = (option) => {
    const currentQuestion = questions[currentQ];
    if (!currentQuestion) return;

    if (option === currentQuestion.correctAnswer) {
      setScore((prev) => prev + 1);
    }
    handleNext();
  };

  const handleNext = () => {
    if (currentQ + 1 < questions.length) {
      setCurrentQ((prev) => prev + 1);
      setTimeLeft(30);
    } else {
      setFinished(true);
    }
  };

  // 🔹 LOGIN PROTECTION
  if (redirectToLogin) {
    return <Navigate to="/login" replace />;
  }

  // 🔹 NO QUESTIONS
  if (questions.length === 0) {
    return (
      <div className="p-6 text-center">
        <h2 className="text-xl font-bold">No questions found 🚨</h2>
        <p className="mt-2 text-gray-600">Please add some questions first.</p>
      </div>
    );
  }

  const currentQuestion = questions[currentQ];

  return (
    <div className="p-6 text-center">
      {!finished ? (
        currentQuestion ? (
          <div>
            <h2 className="text-xl font-bold mb-4">
              Question {currentQ + 1} of {questions.length}
            </h2>

            <p className="mb-4">{currentQuestion.question}</p>

            {/* MCQ */}
            {currentQuestion.type === "MCQ" && (
              <div className="flex flex-col gap-2">
                {currentQuestion.options?.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => handleAnswer(option)}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}

            {/* TRUE / FALSE */}
            {currentQuestion.type === "TrueFalse" && (
              <div className="flex gap-4 justify-center">
                <button
                  onClick={() => handleAnswer("True")}
                  className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600"
                >
                  True
                </button>
                <button
                  onClick={() => handleAnswer("False")}
                  className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
                >
                  False
                </button>
              </div>
            )}

            {/* FULL ANSWER */}
            {currentQuestion.type === "FullAnswer" && (
              <div className="flex flex-col gap-2">
                <input
                  type="text"
                  placeholder="Write your answer"
                  className="border p-2 w-full mt-2 rounded"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleAnswer(e.target.value);
                      e.target.value = "";
                    }
                  }}
                />
              </div>
            )}

            <p className="mt-4 text-red-500 font-bold">
              Time Left: {timeLeft}s
            </p>
          </div>
        ) : (
          <p>Loading question...</p>
        )
      ) : (
        <div>
          <h2 className="text-2xl font-bold">Test Finished 🎉</h2>
          <p className="mt-4">
            Your Score: {score} / {questions.length}
          </p>
        </div>
      )}
    </div>
  );
};

export default Test;
